import React from 'react';
const steps = [{
  number: '01',
  title: 'Discovery',
  description: 'We dive deep into your business goals, target audience, and competitors to understand your unique position.'
}, {
  number: '02',
  title: 'Strategy',
  description: 'Our experts craft a bespoke roadmap combining SEO, PPC, and content to hit your specific KPIs.'
}, {
  number: '03',
  title: 'Execution',
  description: 'We implement the strategy with precision, optimizing technical elements and launching targeted campaigns.'
}, {
  number: '04',
  title: 'Growth',
  description: 'Continuous monitoring, testing, and refining to scale your results and maximize return on investment.'
}];
export function Process() {
  return <section id="process" className="py-24 bg-slate-900 text-white" data-id="element-146">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-147">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-148">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-149">
            Our Proven Process
          </h2>
          <p className="text-lg text-slate-400" data-id="element-150">
            A systematic approach to digital dominance. We leave nothing to
            chance.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-151">
          {steps.map((step, index) => <div key={index} className="relative group" data-id="element-152">
              {index < steps.length - 1 && <div className="hidden lg:block absolute top-8 left-1/2 w-full h-0.5 bg-slate-800 -z-10" data-id="element-153"></div>}
              <div className="bg-slate-800/50 p-8 rounded-2xl border border-slate-700 hover:border-emerald-500/50 transition-all duration-300 h-full" data-id="element-154">
                <div className="w-16 h-16 bg-slate-800 rounded-full flex items-center justify-center text-2xl font-bold text-emerald-500 mb-6 border-4 border-slate-900 shadow-xl group-hover:scale-110 transition-transform duration-300" data-id="element-155">
                  {step.number}
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-156">{step.title}</h3>
                <p className="text-slate-400 leading-relaxed" data-id="element-157">
                  {step.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}